import React, { Component } from 'react';
import MobilePullablePanel from '@tencent/docs-scenario-components-mobile-panel';
import FastClick from '@tencent/docs-scenario-components-utils/dist/fastclick';
import { isAndroid } from '@tencent/docs-user-agent/pure';
import { Tabs } from '@tencent/dui-mobile';
import { MobileMenuTitlebar } from './mobile-menu-titlebar.js';
import { MobileMenuState } from './mobile-menu.interface.js';
import { MobileStaticPanel } from './panel.js';

/**
 * 菜单组件
 * @internal
 */
class MobileMenu extends Component {
    get defaultPanelHeight() {
        return window.innerHeight * 0.5;
    }
    constructor(props) {
        var _a, _b, _c;
        super(props);
        this.panelInstance = React.createRef();
        this.subMenuInstance = React.createRef();
        this.show = false;
        this.activeTab = -1;
        this.defaultTabIndex = Math.max((_b = (_a = this.props.tabs) === null || _a === void 0 ? void 0 : _a.findIndex(tab => tab.label === this.props.defaultTab)) !== null && _b !== void 0 ? _b : 0, 0);
        this.previousWindowHeight = window.innerHeight;
        this.pushSubmenu = (submenu) => {
            const height = window.innerHeight / 2;
            this.setState({
                submenuStack: [...this.state.submenuStack, submenu],
                parentMenuHeightStack: [...this.state.parentMenuHeightStack, height],
                parentMenuActiveTabStack: [...this.state.parentMenuActiveTabStack, this.activeTab],
            }, () => {
                var _a, _b;
                // 子菜单高度为屏幕高度50%
                (_b = (_a = this.panelInstance.current) === null || _a === void 0 ? void 0 : _a.reset) === null || _b === void 0 ? void 0 : _b.call(_a, height);
                this.onSubMenuShow();
            });
        };
        this.popSubmenu = () => {
            const parentMenuHeight = this.state.parentMenuHeightStack.slice(-1)[0];
            const parentMenuActiveTab = this.state.parentMenuActiveTabStack.slice(-1)[0];
            if (parentMenuActiveTab >= 0) {
                this.defaultTabIndex = parentMenuActiveTab;
                // this.changeTab(parentMenuActiveTab.toString(), false);
            }
            this.setState({
                submenuStack: this.state.submenuStack.slice(0, -1),
                parentMenuHeightStack: this.state.parentMenuHeightStack.slice(0, -1),
                parentMenuActiveTabStack: this.state.parentMenuActiveTabStack.slice(0, -1),
            }, () => {
                var _a, _b;
                // 从子菜单返回时，回到父级菜单记忆的高度
                (_b = (_a = this.panelInstance.current) === null || _a === void 0 ? void 0 : _a.reset) === null || _b === void 0 ? void 0 : _b.call(_a, parentMenuHeight);
            });
        };
        this.popAllSubmenus = () => {
            this.setState({
                submenuStack: [],
            });
        };
        this.changeTab = (index, reset = true) => {
            var _a, _b, _c, _d, _e, _f;
            const i = parseInt(index, 10);
            const tab = (_a = this.props.tabs) === null || _a === void 0 ? void 0 : _a[i];
            this.activeTab = i;
            this.setState({
                groups: (_c = (_b = tab === null || tab === void 0 ? void 0 : tab.groups) !== null && _b !== void 0 ? _b : this.props.groups) !== null && _c !== void 0 ? _c : [],
                resetFlag: this.state.resetFlag + 1,
            });
            if (reset) {
                (_e = (_d = this.panelInstance.current) === null || _d === void 0 ? void 0 : _d.reset) === null || _e === void 0 ? void 0 : _e.call(_d);
            }
            (_f = tab === null || tab === void 0 ? void 0 : tab.onActive) === null || _f === void 0 ? void 0 : _f.call(tab);
            // 切换tab，内容滚动到顶部
            const scrollerWrapper = document.querySelector('.mobile-pull-panel-v2-children-scroller');
            if (scrollerWrapper) {
                scrollerWrapper.scrollTop = 0;
            }
            const scrollerContent = document.querySelector('.mobile-menu-panel-v2-content');
            if (scrollerContent) {
                scrollerContent.scrollTop = 0;
            }
        };
        this.renderTitle = () => {
            var _a, _b;
            let title = '';
            const isSubMenu = this.state.submenuStack.length > 0;
            if (isSubMenu) {
                title = this.state.submenuStack.slice(-1)[0].title;
            }
            else {
                title = (_a = this.props.titleBar) === null || _a === void 0 ? void 0 : _a.title;
            }
            if (this.props.tabs && !isSubMenu) {
                return React.createElement(Tabs, { onChange: this.changeTab, defaultActiveId: `${this.defaultTabIndex}`, style: { background: 'transparent' }, tabBarStyle: { paddingLeft: 0, height: 56, boxSizing: 'border-box' }, tabBarItemStyle: {
                        paddingLeft: 0, paddingRight: 0, marginRight: 16, marginLeft: 16,
                        fontSize: 16,
                        color: 'var(--TDoc-Light-Text-text-medium, rgba(0, 0, 0, 0.48))',
                    }, indicatorStyle: { background: '#1F1F1F' }, indicatorWidth: 24, activeItemStyle: { color: 'var(--TDoc-Light-Text-text-ultrastrong, rgba(0, 0, 0, 0.88))', fontWeight: 600 }, alignment: "left", tabBarAdditionalContent: this.props.showCloseButton
                        ? React.createElement("div", { className: "mobile-menu-panel-v2-tab-close", onClick: (e) => {
                                e.stopPropagation();
                                this.hidePanel();
                            } })
                        : null }, this.props.tabs.map((tab, i) => React.createElement(Tabs.TabPane, { tab: tab.label, id: `${i}`, key: i })));
            }
            return React.createElement(MobileMenuTitlebar, Object.assign({}, ((_b = this.props.titleBar) !== null && _b !== void 0 ? _b : {}), { title: title, isSubMenu: isSubMenu, show: !!this.props.titleBar, label: this.props.label, onClose: (e) => {
                    e.stopPropagation();
                    this.hidePanel();
                }, onPop: this.popSubmenu }));
        };
        this.renderItem = (item, index) => {
            var _a, _b, _c, _d;
            const longTapTime = (_a = this.props.longTapTime) !== null && _a !== void 0 ? _a : 1500;
            return (React.createElement("div", { className: `mobile-menu-panel-v2-item ${item.isHighlight
                    ? 'mobile-menu-panel-v2-item-highlight '
                    : ''}${(_b = item.className) !== null && _b !== void 0 ? _b : ''}${item.isDisabled ? ' mobile-menu-panel-v2-item-disabled' : ''}${item.isSolid ? ' mobile-menu-panel-v2-item-solid' : ''}`, key: `mobile-menu-panel-v2-item-${this.state.resetFlag}-${index}`, onTouchStart: (e) => {
                    const target = e.target;
                    const touch = e.touches[0];
                    target.touchX = touch.clientX;
                    target.touchY = touch.clientY;
                    target.touchT = Date.now();
                    target.longTapTick = setTimeout(() => {
                        var _a;
                        try {
                            if (item.onLongTap) {
                                item.onLongTap(e);
                            }
                        }
                        finally {
                            (_a = this.panelInstance.current) === null || _a === void 0 ? void 0 : _a.hide();
                            this.dispatchMobileMenuStateChangeEvent(true);
                        }
                    }, longTapTime);
                }, onTouchMove: (e) => {
                    const target = e.target;
                    const touch = e.touches[0];
                    const x = touch.clientX;
                    const y = touch.clientY;
                    if (Math.abs(y - target.touchY) > 10 || Math.abs(x - target.touchX) > 10) {
                        clearTimeout(target.longTapTick);
                    }
                }, onTouchEnd: (e) => {
                    const target = e.target;
                    clearTimeout(target.longTapTick);
                }, onMouseUp: (e) => {
                    const target = e.target;
                    clearTimeout(target.longTapTick);
                }, onClick: (e) => {
                    // 如果菜单项被禁用则什么也不做
                    if (item.isDisabled) {
                        return;
                    }
                    // 如果有子菜单，直接进子菜单，不做别的事情
                    if (item.submenu) {
                        // 这里竟然识别不了 submenu 变成非空了，还得转成 any
                        return this.pushSubmenu(item);
                    }
                    // 如果没有子菜单，触发点击事件，如果没有 preventDefault 则关闭面板
                    try {
                        if (item.onClick) {
                            item.onClick(e);
                        }
                    }
                    finally {
                        if (!e.isDefaultPrevented()) {
                            setTimeout(() => {
                                var _a;
                                (_a = this.panelInstance.current) === null || _a === void 0 ? void 0 : _a.hide();
                                this.dispatchMobileMenuStateChangeEvent(true);
                            }, 100);
                        }
                    }
                } },
                ((_c = item.icon) !== null && _c !== void 0 ? _c : item.iconClass) && ( // 如果 icon 是 一个 react 组件, 作为子节点进行渲染
                (item.icon instanceof Object)
                    ? React.createElement("div", { className: "mobile-menu-panel-v2-item-icon" }, item.icon)
                    : React.createElement("div", { className: `mobile-menu-panel-v2-item-icon ${(_d = item.iconClass) !== null && _d !== void 0 ? _d : ''}`, style: item.icon ? { backgroundImage: `url(${item.icon})` } : {} })),
                React.createElement("div", { className: "mobile-menu-panel-v2-item-title" }, item.title),
                item.redpoint
                    ? (React.createElement("div", { className: `mobile-menu-panel-v2-item-redpoint ${item.redpoint === true ? '' : 'mobile-menu-panel-v2-item-redpoint-with-text'}` }, item.redpoint !== true && (typeof item.redpoint === 'number'
                        ? Math.round(item.redpoint)
                        : item.redpoint)))
                    : null,
                React.createElement("div", { className: "mobile-menu-panel-v2-item-spacing" }),
                item.tip && (React.createElement("div", { className: "mobile-menu-panel-v2-item-tip" }, item.tip)),
                item.isVipOnly && (React.createElement("div", { className: "mobile-menu-panel-v2-item-vip" })),
                item.customElement));
        };
        this.renderIntroduction = () => {
            var _a;
            const introduction = (_a = this.props.titleBar) === null || _a === void 0 ? void 0 : _a.introduction;
            if (!introduction)
                return null;
            return (React.createElement("div", { className: "mobile-menu-panel-introduction" }, introduction));
        };
        this.renderContent = (groups) => {
            var _a, _b, _c;
            // 如果在子菜单中，直接渲染子菜单内容
            if (this.state.submenuStack.length) {
                const currentSubmenu = this.state.submenuStack.slice(-1)[0];
                return (React.createElement("div", { className: "mobile-menu-panel-v2-group mobile-menu-panel-v2-group-submenu", ref: this.subMenuInstance }, currentSubmenu.submenu.filter(item => item.condition !== false).map(this.renderItem)));
            }
            // 如果在主菜单中，渲染主菜单内容
            const totalItemsCount = groups
                .map(group => group.items.filter(k => k.condition !== false).length)
                .reduce((a, b) => a + b, 0);
            const activeTabtitleBar = (_c = (_b = (_a = this.props) === null || _a === void 0 ? void 0 : _a.tabs) === null || _b === void 0 ? void 0 : _b[this.activeTab]) === null || _c === void 0 ? void 0 : _c.titleBar;
            return React.createElement("div", { className: "mobile-menu-panel-v2-content" },
                activeTabtitleBar && React.createElement(MobileMenuTitlebar, Object.assign({}, (activeTabtitleBar !== null && activeTabtitleBar !== void 0 ? activeTabtitleBar : {}), { isSubMenu: false, showCloseBtn: false, show: true, onClose: (e) => {
                        e.stopPropagation();
                        this.hidePanel();
                    } })),
                (groups.map((group, i) => {
                    const visibleItems = (group.items || []).filter(item => item.condition !== false);
                    // 分组无可见内容时不展示分组
                    if (!visibleItems.length)
                        return null;
                    // 分组可见内容只有一条时，横向分组改为纵向展示
                    // 总可见内容不超过四条时，横向分组改为纵向展示
                    const { showType = 'normal', columns } = group;
                    let actualShowType = showType;
                    if ((totalItemsCount <= 4 || visibleItems.length === 1) && showType === 'horizontal') {
                        actualShowType = 'normal';
                    }
                    // 没有指定每行展示几列，且可见分组超过4条时，其余纵向展示
                    if (visibleItems.length > 4 && showType === 'horizontal' && !columns) {
                        return React.createElement("div", { key: `group-${i}`, className: "mobile-menu-panel-v2-group mobile-menu-panel-v2-group-mixed" },
                            React.createElement("div", { className: "mobile-menu-panel-v2-group mobile-menu-panel-v2-group-horizontal" }, visibleItems.slice(0, 4).map(this.renderItem)),
                            React.createElement("div", { className: "mobile-menu-panel-v2-group mobile-menu-panel-v2-group-normal" }, visibleItems.slice(4).map(this.renderItem)));
                    }
                    return (React.createElement("div", { className: `mobile-menu-panel-v2-group mobile-menu-panel-v2-group-${actualShowType} ${(actualShowType === 'horizontal' && columns) ? `mobile-menu-panel-v2-group-horizontal-${columns}` : ''}`, key: `group-${i}` }, visibleItems.map(this.renderItem)));
                })));
        };
        this.showPanel = () => {
            var _a;
            (_a = this.panelInstance.current) === null || _a === void 0 ? void 0 : _a.show();
        };
        this.onWindowResize = () => {
            const currentHeight = window.innerHeight; // 获取当前窗口高度
            if (this.previousWindowHeight === currentHeight) {
                return;
            }
            const height = (this.state.panelHeight / this.previousWindowHeight) * currentHeight;
            this.previousWindowHeight = currentHeight;
            this.setState({ panelHeight: height });
        };
        this.onColorChange = () => {
            setTimeout(() => this.forceUpdate(), 100);
        };
        this.withContainer = (content) => {
            var _a;
            const scrollStyle = this.props.showPullHandle
                ? { height: 'auto' }
                : { height: (_a = this.state.panelHeight) !== null && _a !== void 0 ? _a : this.defaultPanelHeight };
            if (!isAndroid) {
                return React.createElement(FastClick, null,
                    React.createElement("div", { className: "mobile-menu-panel-v2", style: scrollStyle }, content));
            }
            return React.createElement("div", { className: "mobile-menu-panel-v2", style: scrollStyle }, content);
        };
        this.render = () => {
            const isSubmenu = !!this.state.submenuStack.length;
            const MobilePanel = this.props.showPullHandle
                ? MobilePullablePanel
                : MobileStaticPanel;
            const { style: initialStyle, showPullHandle } = this.props;
            const { panelHeight } = this.state;
            const bottom = this.props.hasSafeAreaInsetBottom ? 34 : 16;
            let style = initialStyle;
            if (window.innerWidth > 480 && window.innerHeight > 480) {
                // 面板 bottom 为底部安全区域+ action-button 高度+ 距离action-button 16px
                style = Object.assign({ bottom: bottom + 64 + 16 }, style);
                if (showPullHandle) {
                    // 可拖拽面板在屏幕宽度和高度都大于480时的布局，通过 transform 设置的默认高度失效，通过传入 height 来控制高度
                    style = Object.assign({ height: panelHeight }, style);
                }
            }
            else if (window.innerWidth > 480 && window.innerHeight <= 480) {
                // 面板宽度与设备高度一致，高度距离底部有安全区域时为34，无则16
                style = Object.assign({ width: window.innerHeight, height: window.innerHeight - 38 - bottom }, style);
            }
            return (React.createElement(MobilePanel
            // 为了性能以及某些兼容性问题，只对 iOS 开启毛玻璃效果
            , { 
                // 为了性能以及某些兼容性问题，只对 iOS 开启毛玻璃效果
                isBackgroundBlur: !isAndroid, clickMaskDestoryPanel: this.props.clickMaskDestoryPanel, className: [
                    isSubmenu ? 'mobile-menu-panel-v2-submenu-container' : 'mobile-menu-panel-v2-main-container',
                    'mobile-menu-panel-v2-handleless',
                ].join(' '), style: style, ref: this.panelInstance, onShow: this.onMenuShow, preferredHeight: panelHeight, onHide: () => { this.dispatchMobileMenuStateChangeEvent(true); } },
                !this.props.content && this.withContainer(React.createElement(React.Fragment, null,
                    this.renderTitle(),
                    this.renderIntroduction(),
                    this.renderContent(this.state.groups))),
                this.props.content && this.withContainer(this.props.content)));
        };
        // 提供一个隐藏面板的接口
        this.hidePanel = (destory = true) => {
            var _a;
            if ((_a = this.panelInstance) === null || _a === void 0 ? void 0 : _a.current) {
                this.panelInstance.current.hide(destory);
                this.dispatchMobileMenuStateChangeEvent(true);
            }
        };
        this.isShown = () => this.show;
        this.onHide = () => {
            this.show = false;
        };
        this.onSubMenuShow = () => {
            const isSubmenu = !!this.state.submenuStack.length;
            if (isSubmenu) {
                // 如果是子菜单则调用子菜单的onShow
                const currentSubmenu = this.state.submenuStack.slice(-1)[0];
                currentSubmenu.submenu.filter(item => item.condition !== false).forEach((item) => {
                    if (typeof item.onShow === 'function') {
                        item.onShow();
                    }
                });
            }
        };
        this.onMenuShow = () => {
            this.show = true;
            this.changeTab(`${this.defaultTabIndex}`, false);
            this.state.groups.forEach((group) => {
                if (group.items) {
                    group.items.forEach((item) => {
                        if (item.condition !== false) {
                            // true 或者 undefined
                            // 为每个可见的列表项执行曝光回调，方便上报以及异步改变状态用
                            if (typeof item.onShow === 'function') {
                                item.onShow();
                            }
                        }
                    });
                }
            });
        };
        this.dispatchMobileMenuStateChangeEvent = (isHide) => {
            document.dispatchEvent(new CustomEvent('MobileMenuStateChanged', {
                detail: { isHide },
            }));
            this.onHide();
        };
        this.state = Object.assign(Object.assign({}, new MobileMenuState()), { panelHeight: (_c = this.props.preferredHeight) !== null && _c !== void 0 ? _c : this.defaultPanelHeight });
    }
    componentDidMount() {
        var _a;
        // 监听客户端在列表设置高亮透传的事件
        (_a = window.mqq) === null || _a === void 0 ? void 0 : _a.addEventListener('setPersonalizedColor', this.onColorChange);
        window.addEventListener('resize', this.onWindowResize);
    }
    componentDidUpdate(prevProps) {
        var _a, _b;
        if (prevProps.preferredHeight !== this.props.preferredHeight) {
            this.setState({ panelHeight: (_a = this.props.preferredHeight) !== null && _a !== void 0 ? _a : this.defaultPanelHeight });
        }
        if ((_b = this.subMenuInstance) === null || _b === void 0 ? void 0 : _b.current) {
            this.subMenuInstance.current.scrollTop = 0;
        }
    }
    componentWillUnmount() {
        var _a;
        // 取消监听客户端在列表设置高亮透传的事件
        (_a = window.mqq) === null || _a === void 0 ? void 0 : _a.removeEventListener('setPersonalizedColor', this.onColorChange);
        window.removeEventListener('resize', this.onWindowResize);
    }
}

export { MobileMenu as default };
//# sourceMappingURL=mobile-menu.js.map
